<template>
    <div v-if="!expense.for_destroy" class="additional-cost">
        <h3 class="title">
            {{ $t('f_extra_cost_title') }} {{ index + 1 }}
            <span class="remove icon icon-cross" @click="removeExpense(expense.id)" />
        </h3>

        <div class="own-input upload-wrap">
            <div>
                {{ $t('f_receipt_label') }}
                <info-tip :text="$t('f_receipt_label_tip_text')" />
            </div>
            <file-preview
                v-if="expense.receipt.name"
                :file="expense.receipt"
                :name="`expenses[${index}][receipt]`"
                @change="selectReceipt()" />
            <label v-show="!expense.receipt.name" class="upload-file">
                <div class="btn btn-upload">
                    <b>+</b> {{ $t('f_upload_receipt_btn') }}
                </div>
                <input
                    ref="receipt_input"
                    type="file"
                    @change="uploadExpenseProccesing(index, $event)">
            </label>
        </div>

        <div class="own-input">
            <label :for="`cost_type_${index}`">{{ $t('f_cost_type_label') }}</label>
            <div class="select-wrap">
                <span class="icon icon-chevron-up" />
                <select
                    :id="`cost_type_${index}`"
                    v-model="expense.cost_type"
                    v-validate="'required'"
                    v-m-android-focus
                    :name="`expenses[${index}][cost_type]`">
                    <option value="">
                        {{ $t('f_cost_type_placeholder') }}
                    </option>
                    <option value="Food and beverage">
                        {{ $t('f_ct_food_and_beverage') }}
                    </option>
                    <option value="Accomodation">
                        {{ $t('f_ct_accommodation') }}
                    </option>
                    <option value="Transportation">
                        {{ $t('f_ct_tansportation') }}
                    </option>
                    <option value="Plane tickets">
                        {{ $t('f_ct_plane_tickets') }}
                    </option>
                    <option value="Other">
                        {{ $t('f_ct_other') }}
                    </option>
                </select>
            </div>
            <span class="error-message">{{ errors.first(`expenses[${index}][cost_type]`) }}</span>
        </div>

        <div v-show="expense.cost_type == 'Other'" class="own-input">
            <label :for="`cost_description_${index}`">{{ $t('f_cots_description_label') }}</label>
            <textarea
                :id="`cost_description_${index}`"
                v-model="expense.cost_description"
                v-m-android-focus
                :name="`expenses[${index}][cost_description]`"
                cols="5"
                rows="5" />
        </div>

        <div v-show="expense.cost_type == 'Plane tickets' && expense.isReceivedRefund != 'skip'" class="own-input">
            <p>
                {{ $t('f_have_you_received_a_refound') }}
            </p>

            <div v-if="$device.mobile()" class="inline-input yes-no-wrap">
                <div class="own-input">
                    <label class="checkbox-container">
                        {{ $t('f_yes') }}
                        <input
                            v-model="expense.isReceivedRefund"
                            :value="true"
                            :name="`isReceivedRefund-yes_${index}`"
                            type="radio">
                        <span class="checkmark" />
                    </label>
                </div>
                <div class="own-input">
                    <label class="checkbox-container">
                        {{ $t('f_no') }}
                        <input
                            v-model="expense.isReceivedRefund"
                            :value="false"
                            :name="`isReceivedRefund-no${index}`"
                            type="radio">
                        <span class="checkmark" />
                    </label>
                </div>
            </div>

            <div v-else class="inline-desktop inline-input isReceivedRefund">
                <div class="own-input">
                    <div class="check-btn">
                        <input
                            :id="`isReceivedRefund-yes_${index}`"
                            v-model="expense.isReceivedRefund"
                            :value="true"
                            :name="`isReceivedRefund-yes_#{index}`"
                            type="radio">
                        <label :for="`isReceivedRefund-yes_${index}`">
                            {{ $t('f_yes') }}
                        </label>
                    </div>
                </div>
                <div class="own-input">
                    <div class="check-btn">
                        <input
                            :id="`isReceivedRefund-no${index}`"
                            v-model="expense.isReceivedRefund"
                            :value="false"
                            :name="`isReceivedRefund-no${index}`"
                            type="radio">
                        <label :for="`isReceivedRefund-no${index}`">
                            {{ $t('f_no') }}
                        </label>
                    </div>
                </div>
            </div>

            <div v-show="expense.cost_type == 'Plane tickets' && expense.isReceivedRefund != undefined" class="hint">
                <span v-show="expense.isReceivedRefund">
                    {{ $t('f_ct_plane_tickets_hint_1') }}
                </span>

                <!--         <span v-show="expense.isReceivedRefund == false">
          {{ $t('f_ct_plane_tickets_hint_2') }}
        </span> -->
            </div>
        </div>

        <div v-show="amountInputsVisibility" class="inline-input amount-inputs">
            <div class="own-input">
                <label :for="`exp_amount_${index}`">{{ $t('f_amount_label') }}</label>
                <input
                    :id="`exp_amount_${index}`"
                    v-model="expense.amount"
                    v-validate="'required|min_value:0.01'"
                    v-m-android-focus
                    :name="`expenses[${index}][amount]`"
                    pattern="\d*"
                    type="number"
                    step="0.01">
                <span class="error-message">{{ errors.first(`expenses[${index}][amount]`) }}</span>
            </div>

            <div class="own-input">
                <label :for="`currency${index}`">
                    {{ $t('f_currency_label') }}
                </label>
                <div class="select-wrap">
                    <span class="icon icon-chevron-up" />
                    <select
                        :id="`currency${index}`"
                        v-model="expense.currency"
                        v-validate="'required'"
                        v-m-android-focus
                        :name="`expenses[${index}][currency]`">
                        <option value="">
                            Please select
                        </option>
                        <option v-for="(value, i) of currenciesMapper" :key="i" :value="value">
                            {{ value }}
                        </option>
                    </select>
                </div>
                <span class="error-message">{{ errors.first(`expenses[${index}][currency]`) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
  import FilePreview from '../common/FilePreview'

  export default {
    components: { FilePreview },
    inject: ['$validator'],
    props: ['index', 'expense'],
    computed: {
      amountInputsVisibility() {
        return this.expense.cost_type != 'Plane tickets' ||
        (this.expense.cost_type == 'Plane tickets' && this.expense.isReceivedRefund != undefined)
      },
      currenciesMapper: function() {
        return this.$store.state.round2.currenciesMapper
      }
    },
    methods: {
      uploadExpenseProccesing(index, event) {
        let file = event.target.files[0]
        this.$store.commit('expenses/SET_RECEIPT', {index, file})
      },
      selectReceipt() {
        this.$refs.receipt_input.click()
      },
      removeExpense: function(id) {
        this.$validator.pause()
        this.$store.commit('expenses/REMOVE', id)
        this.$nextTick(() => this.$validator.resume())
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@stylesheets/_vars.scss';

  .additional-cost {
    .title {
      font-size: 18px;
      text-align: center;
      position: relative;
      padding: 12px 0;
      border: 1px solid $light_gray_a;
      background-color: $light_gray_c;
      .content {
        top: auto;
        bottom: 43px;
      }
    }

    .upload-wrap {
      .content {
        bottom: 97px;
      }
      .upload-file {
        .btn-upload{
          margin-top: 10px; 
        }
        input {
          display: none;
        }
      }
    }

    .inline-desktop.inline-input.isReceivedRefund{
      margin-bottom: 25px;
    }

    .hint {
      color: $gray_b;
      padding: 10px;
      text-align: center;
      border-radius: 8px;
      border: 1px solid $light_gray_a;
    }

    .amount-inputs {
      > div {
        width: 50%;
      }
    }
  }
</style>
